import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'react-feather';
import { useDispatch } from 'react-redux';
import { setAcceptedPolicy } from '../../store/slices/authSlice';
import { useTranslation } from 'react-i18next';

const WelcomePolicy = ({ nextPath = '/auth/first-name', backPath = '/auth/otp' }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handleNext = () => {
        dispatch(setAcceptedPolicy(true));
        navigate(nextPath);
    };

    const policyItems = [
        {
            title: t('welcomePolicy.rules.beYourself.title'),
            description: t('welcomePolicy.rules.beYourself.description')
        },
        {
            title: t('welcomePolicy.rules.staySafe.title'),
            description: t('welcomePolicy.rules.staySafe.description')
        },
        {
            title: t('welcomePolicy.rules.playItCool.title'),
            description: t('welcomePolicy.rules.playItCool.description')
        },
        {
            title: t('welcomePolicy.rules.beProactive.title'),
            description: t('welcomePolicy.rules.beProactive.description')
        },
        {
            title: t('welcomePolicy.rules.goldenRule.title'),
            description: t('welcomePolicy.rules.goldenRule.description')
        }
    ];

    return (
        <div className="page-wrapper">
            <div className="page-content">
                <div className="container">
                    <div className="account-area style-2">
                        {/* Retour vers l'étape précédente de la logique du parcours (pas l'historique du navigateur : */}
                        {/* la redirection automatique de ProtectedAuthRoute peut remplacer l'historique réel) */}
                        <a href="#" onClick={(e) => { e.preventDefault(); navigate(backPath); }} className="back-btn">
                            <ChevronLeft className="icon" />
                        </a>
                        <div className="section-head ps-0 border-bottom">
                            <h2 className="mb-2">{t('welcomePolicy.title')}</h2>
                            <p>{t('welcomePolicy.subtitle')}</p>
                        </div>
                    </div>
                    <ul className="policy-content">
                        {policyItems.map((item, index) => (
                            <li key={index}>
                                <h4>{item.title}</h4>
                                <p>{item.description}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            {/* Footer */}
            <div className="footer fixed bg-white p-b15">
                <div className="container">
                    <button 
                        onClick={handleNext}
                        className="btn btn-lg btn-gradient w-100 dz-flex-box btn-shadow rounded-xl"
                    >
                        {t('welcomePolicy.agree')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WelcomePolicy;
